module.exports = __webpack_public_path__ + "2710069db27933cbb6dc1393adff4266.png";